import { render, staticRenderFns } from "./CardPanelaco.vue?vue&type=template&id=220bd6ac&scoped=true"
import script from "./CardPanelaco.vue?vue&type=script&lang=js"
export * from "./CardPanelaco.vue?vue&type=script&lang=js"
import style0 from "./CardPanelaco.vue?vue&type=style&index=0&id=220bd6ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bd6ac",
  null
  
)

export default component.exports